import { schema } from '@Schema/schema';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS, Permission } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/incidents/incidents/visual/')({
  validateSearch: zodValidator(schema.VISUAL_EXPLORER),
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.INCIDENTS, permission: Permission.READ });
    context.validatePermissions({ isAllowed, preload });
  },
});
